import { CardGrid } from '@/ui/card-grid/card-grid';
import { Stack } from '@/ui/line/line';

import { SpotlightCompaniesControls } from './spotlight-companies-controls';
import { SpotlightCompanyCard } from './spotlight-company-card';
import {
  CARD_ANIMATION_STAGGER_MS,
  PAGE_SIZE,
  useSpotlightCompaniesListing,
} from './use-spotlight-companies-listing';

export const SpotlightCompaniesListing = () => {
  const {
    displayedCompanies,
    displayedTotalItems,
    handleClearStageFilters,
    handleCloseStageFiltersPanel,
    handleRemoveSearch,
    handleSearchPhraseChange,
    handleToggleStageFilter,
    handleToggleStageFiltersPanel,
    hasActiveStageFilters,
    isFilterControlActive,
    isSortControlActive,
    isStageFilterOpen,
    listingStages,
    page,
    searchValue,
    selectedStageFilters,
    setIsSortDropdownOpen,
    setPage,
    setSortMode,
    shouldShowLoadingSkeletons,
    sortMode,
  } = useSpotlightCompaniesListing();

  return (
    <Stack gap="32px">
      <SpotlightCompaniesControls
        displayedCompaniesCount={displayedCompanies.length}
        displayedTotalItems={displayedTotalItems}
        handleClearStageFilters={handleClearStageFilters}
        handleCloseStageFiltersPanel={handleCloseStageFiltersPanel}
        handleRemoveSearch={handleRemoveSearch}
        handleSearchPhraseChange={handleSearchPhraseChange}
        handleToggleStageFilter={handleToggleStageFilter}
        handleToggleStageFiltersPanel={handleToggleStageFiltersPanel}
        hasActiveStageFilters={hasActiveStageFilters}
        isFilterControlActive={isFilterControlActive}
        isSortControlActive={isSortControlActive}
        isStageFilterOpen={isStageFilterOpen}
        listingStages={listingStages}
        searchValue={searchValue}
        selectedStageFilters={selectedStageFilters}
        setIsSortDropdownOpen={setIsSortDropdownOpen}
        setSortMode={setSortMode}
        sortMode={sortMode}
      />
      <CardGrid
        columns={3}
        responsiveColumns={{ belowSm: 1, sm: 2 }}
        isLoading={shouldShowLoadingSkeletons}
        pagination={{
          onPageChange: setPage,
          page,
          pageSize: PAGE_SIZE,
          totalItems: displayedTotalItems,
        }}
      >
        {displayedCompanies.map((company, index) => (
          <SpotlightCompanyCard
            key={company.id}
            company={company}
            delayMs={index * CARD_ANIMATION_STAGGER_MS}
            listingStages={listingStages}
          />
        ))}
      </CardGrid>
    </Stack>
  );
};
